import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

export const navbarStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        mainToolbar: {
            backgroundColor: '#575756',
            height: 57,
        },
        mainLogo: {
            // backgroundColor: '#E2000F',
            backgroundColor: '#b6000f',
            padding: '0 10px',
            height: '100%',
            width: 104,
            position: 'absolute',
            left: '0',
        },
        logo: {
            height: '100%',
            width: '100%',
        },

        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        userButton: {
            marginLeft: '10px', 
            textTransform: 'none', 
            fontWeight: 'bold', 
            color:'#fff',
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
        menuButton: {
            marginRight: theme.spacing(2),
            color: '#575756',
        },
    }),
);